import CIMSTable from 'components/CIMSTable'
import TargetsProvider, { useTargetsContext } from './TargetsContext'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useCreate } from './hooks/useCreate'
import { useRestore } from './hooks/useRestore'
import { useEdit } from './hooks/useEdit'

const InnerTargetsTable: React.VFC = () => {
  const { targets, loading, refetch: onReload } = useTargetsContext()
  return (
    <CIMSTable
      loading={loading}
      records={targets}
      rowKey="id"
      columns={useColumns()}
      expand={useExpand()}
      actions={{
        header: { onReload, create: useCreate() },
        row: { edit: useEdit(), remove: useRemove(), restore: useRestore() },
      }}
    />
  )
}

const Targets: React.VFC = () => {
  return (
    <TargetsProvider>
      <InnerTargetsTable />
    </TargetsProvider>
  )
}

export default Targets
